<template>
  <div
    class="select-div position-relative"
    ref="customSelect"
    @keydown="handleKeyPress"
    tabindex="0"
    @focusout="closeDropdownOnFocusOut"
  >
    <div
      ref="landingdrop"
      @click="
        !disableDropdown &&
          dropdownOptions.length != 0 &&
          (openDropdown = !openDropdown)
      "
      class="
        laptopinput
        d-flex
        align-items-center
        justify-content-between
        position-relative
        mt-1
      "
      :class="
        showError
          ? 'addUser-error pointer'
          : disableDropdown
          ? 'disable-inputField'
          : 'pointer'
      "
      :style="
        $route.name == 'TalentPool' && id === 'custom'
          ? 'height: 40px; top: 1px;'
          : checkRoute
          ? 'height: 40px;'
          : ''
      "
    >
      <span v-if="type == 'filter'" :class="!value && 'input-empty-placeholder'"
        >{{ value && value != undefined ? displayText : placeholder }}
      </span>
      <span v-else :class="!value && 'input-empty-placeholder'"
        >{{ value ? text : placeholder }}
      </span>
      <img
        v-if="!openDropdown"
        src="../../assets/cvsearch/cv-downarrow.svg"
        alt=""
      />
      <img
        v-else
        class="pointer"
        src="../../assets/cvsearch/cv-uparrow.svg"
        alt=""
      />
      <div
        v-if="showError && id !== 'access' && id !== 'interview'"
        class="access-validationicon-dash-2"
      >
        <img src="../../assets/deletepopupicon.svg" alt="" />
      </div>
    </div>

    <div
      v-closable="{
        exclude: ['landingdrop'],
        handler: 'hideLandingDropdown',
      }"
      v-if="openDropdown && dropdownOptions.length != 0"
      class="pointer"
      :class="
        $route.name == 'TalentPool'
          ? 'landing-dropdown'
          : 'acs-landingpage-dropdown'
      "
    >
      <template v-if="id == 'custom'"
        ><div
          v-for="opt in dropdownOptions"
          :key="opt.value"
          @click.stop="$emit('setValue', opt), (openDropdown = false)"
          :class="value == opt.key ? 'landpage-sel' : 'landpage-unsel'"
          :id="opt.key"
        >
          {{ opt.label }}
        </div></template
      >
      <template v-else-if="id == 'access'">
        <div
          v-for="opt in dropdownOptions"
          :key="opt.value"
          :id="opt.value"
          @click.stop="$emit('setValue', opt), (openDropdown = false)"
          :class="value == opt.value ? 'landpage-sel' : 'landpage-unsel'"
        >
          {{ opt.text }}
        </div>
      </template>
      <template v-else>
        <div
          v-for="opt in dropdownOptions"
          :key="opt.value"
          :id="opt.value"
          @click.stop="$emit('setValue', opt.value), (openDropdown = false)"
          :class="value == opt.value ? 'landpage-sel' : 'landpage-unsel'"
        >
          {{ opt.text }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectDropdown",
  props: {
    id: String,
    showError: Boolean,
    disableDropdown: Boolean,
    text: String,
    value: String,
    placeholder: String,
    type: String,
    dropdownOptions: Array,
  },
  data() {
    return {
      openDropdown: false,
    };
  },
  created() {
    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside);
    this.$refs.customSelect.removeEventListener(
      "focus",
      this.openDropdownOnFocus
    );
  },
  methods: {
    hideLandingDropdown() {
      this.openDropdown = false;
    },
    openDropdownOnFocus() {
      this.openDropdown = true;
    },
    handleKeyPress(event) {
      if (this.id == "custom") {
        this.customHandleKeyPress(event);
      } else {
        this.nonCustomHandleKeyPress(event);
      }
    },
    customHandleKeyPress(event) {
      const options = this.dropdownOptions;
      const selectedIndex = options.findIndex(
        (option) => option.key === this.value
      );

      if (event.key === "ArrowDown" && selectedIndex < options.length - 1) {
        // Move selection down
        if (!this.openDropdown) {
          this.openDropdown = true;
        }
        let value = options[selectedIndex + 1].disabled
          ? this.value
          : options[selectedIndex + 1];

        const selectedOptionElement = document.getElementById(value);
        if (selectedOptionElement) {
          selectedOptionElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
        this.$emit("setValue", value);
        event.preventDefault(); // Prevent default behavior
      } else if (event.key === "ArrowUp" && selectedIndex > 0) {
        // Move selection up
        let value = options[selectedIndex - 1].disabled
          ? this.value
          : options[selectedIndex - 1];
        const selectedOptionElement = document.getElementById(value);
        if (selectedOptionElement) {
          selectedOptionElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
        this.$emit("setValue", value);
        event.preventDefault(); // Prevent default behavior
      } else if (event.key === "Enter") {
        this.toggleOptions();
      }
    },
    nonCustomHandleKeyPress(event) {
      const options = this.dropdownOptions;
      const selectedIndex = options.findIndex(
        (option) => option.value === this.value
      );

      if (event.key === "ArrowDown" && selectedIndex < options.length - 1) {
        // Move selection down
        if (!this.openDropdown) {
          this.openDropdown = true;
        }
        let value = options[selectedIndex + 1].disabled
          ? this.value
          : options[selectedIndex + 1].value;

        const selectedOptionElement = document.getElementById(value);
        if (selectedOptionElement) {
          selectedOptionElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }

        this.$emit("setValue", value);
        event.preventDefault(); // Prevent default behavior
      } else if (event.key === "ArrowUp" && selectedIndex > 0) {
        // Move selection up
        let value = options[selectedIndex - 1].disabled
          ? this.value
          : options[selectedIndex - 1].value;
        const selectedOptionElement = document.getElementById(value);
        if (selectedOptionElement) {
          selectedOptionElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
        this.$emit("setValue", value);
        event.preventDefault(); // Prevent default behavior
      } else if (event.key === "Enter") {
        this.toggleOptions();
      }
    },

    toggleOptions() {
      this.openDropdown = !this.openDropdown;
      if (this.openDropdown) {
        // If dropdown is being opened, focus on the select box after a small delay
        setTimeout(() => {
          this.$refs.customSelect.focus();
        }, 10); // Adjust the delay time as needed
      }
    },
    closeDropdownOnClickOutside(event) {
      if (!this.$refs.customSelect.contains(event.target)) {
        this.openDropdown = false;
      }
    },
    closeDropdownOnFocusOut(event) {
      // Check if the focus is outside the custom select component
      if (!this.$refs.customSelect.contains(event.relatedTarget)) {
        this.openDropdown = false; // Close the dropdown
      }
    },
  },
  computed: {
    checkRoute() {
      return (
        this.$route.name == "CreateInterviewProcess" ||
        this.$route.name == "EditInterviewProcess" ||
        this.$route.name == "ActivateInterview"
      );
    },
    displayText() {
      const selectedIndex = this.dropdownOptions.findIndex(
        (option) => option.value === this.value
      );

      return selectedIndex > -1
        ? this.dropdownOptions[selectedIndex].text
        : this.placeholder;
    },
  },
};
</script>
<style>
.addUser-error {
  height: 36px;
  padding: 1px 0.75rem;
  border-radius: 8px;
  border: 1px solid red !important;
  background: var(--base-white, var(--bg-white));
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #332d2d;
  font-size: var(--size-14);
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.addUser-error:focus {
  border: 1px solid red;
}

.landing-dropdown {
  position: absolute;
  border: 1px solid #2988e638;
  box-shadow: 0px 8px 15px 0px #00000066;
  min-height: auto;
  max-height: 135px;
  overflow: auto;
  width: 100%;
  border-radius: 4px;
  z-index: 5;
  background: #f9f9f9;
}
</style>
